// extracted by mini-css-extract-plugin
export default {"container":"LeaveGame_container__7CbIE","info":"LeaveGame_info__2VgD0","no":"LeaveGame_no__NIW7p","yes":"LeaveGame_yes__D+elg","wrapper":"LeaveGame_wrapper__X7UTZ"};